<template>
  <BaseListContactsPage
    :tabs="tabs"
    :current-tab="currentTab"
    :contacts-selectable="!massTextIcon.disabled"
    :get-gql-query="getGqlQuery"
    :get-items="getItems"
    :get-total-items-count="getTotalItemsCount"
    :get-query-variables="getQueryVariables"
    :update-context-variable="updateContextVariable"
    :on-tab-changed="onTabChanged"
    :get-total-contacts="getTotalContacts"
  />
</template>

<script>
import BaseListContactsPage from '@/pages/BaseListContactsPage'
import { LIST_CATEGORY_CONTACTS_WITH_WORK } from '@/backend/graphql/categoryGQL'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CategoryContactsPage',
  components: {
    BaseListContactsPage
  },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_CATEGORY_CONTACTS_WITH_WORK,
      limit: 50,
      offset: 0,
      orderBy: '-profile__id,-profile__last_recv_at',
      profileIsDelete: 0,
      window: {
        width: 0,
        height: 0
      },
      tabs: {
        'tab-1': this.$route.query.categoryName
      }
    }
  },
  computed: {
    ...mapGetters({ massTextIcon: 'toolBar/getMassTextIcon' })
  },
  created () {
    // reactive query and variables
    this.categoryId = this.$route.params.categoryId
    this.setEditMenuItems({ val: [
      { title: 'Edit Contacts',
        route: { name: 'editCategoryContacts',
          params: { categoryId: this.categoryId } }
      },
      { title: 'Add Contacts' },
      { title: 'Remove Contacts' }
    ] })
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions({ setEditMenuItems: 'toolBar/setEditMenuItems' }),
    getItems (data) {
      return data.listCategoryProfile.results.map(obj => obj.profile)
    },
    getTotalItemsCount (data) {
      return data.listCategoryProfile.totalCount
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        categoryId: this.categoryId,
        profileIsDelete: this.profileIsDelete
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    getTotalContacts (value) {
      if (value === this.currentTab) { return this.$store.getters['contact/getTotalCount'] } else { return '?' }
    },
    onTabChanged (value) {
      this.currentTab = value
    }
  }
}
</script>

<style scoped>

</style>
